import type { LoginSchema } from '@repo/schemas/auth/login';
import type { PasswordChangeSchema } from '@repo/schemas/auth/passwordChange';
import type { ResetPasswordSchema } from '@repo/schemas/auth/resetPassword';
import type { SignupSchema } from '@repo/schemas/auth/signup';
import type { UserPrivate } from '@repo/types/users';
import type { AxiosResponse } from 'axios';

import { axiosInstance } from '#api-client';

export class AuthService {
  static async postLogin(data: LoginSchema): Promise<AxiosResponse<PostLoginResponse>> {
    return await axiosInstance.post('/auth/login', data);
  }

  static async postLogout(): Promise<AxiosResponse<string>> {
    return await axiosInstance.post('/auth/logout');
  }

  static async getSignup(token?: string): Promise<AxiosResponse<UserPrivate>> {
    return await axiosInstance.get('/auth/signup', {
      params: { t: token },
    });
  }

  static async postSignup(data: SignupSchema): Promise<AxiosResponse<string>> {
    return await axiosInstance.post('/auth/signup', data);
  }

  static async postPasswordReset(data: ResetPasswordSchema): Promise<AxiosResponse<string>> {
    return await axiosInstance.post('/auth/resetPassword', data);
  }

  static async postPasswordChange(data: PasswordChangeSchema): Promise<AxiosResponse<UserPrivate>> {
    return await axiosInstance.post('/auth/passwordChange', data);
  }
  static async getSession(): Promise<AxiosResponse<string>> {
    return await axiosInstance.get('/auth/sessionValid');
  }
}

export interface PostLoginResponse {
  redirectURL: string;
  user: UserPrivate;
}
